import { RecursoFiltro } from 'app/entity/recurso-filtro.model';
import { Component } from '@angular/core';
import { BaseCrudComponent } from '../../base';
import { GerenciamentoPosGraduacao } from '../../entity/gerenciamento-pos-graduacao.model';
import { Validators } from '@angular/forms';
import { SelectItem } from 'primeng/primeng';
import { TipoPosGraduacao } from '../../entity/enumeraveis';
import { dataFimLimite } from 'app/util/custom.validators';

@Component({
  selector: 'gerenciamento-pos-graduacao-crud',
  templateUrl: './crud.component.html'
})
export class GerenciamentoPosGraduacaoCrudComponent extends BaseCrudComponent {

  recursoFiltro: RecursoFiltro = new RecursoFiltro();
  controllerName = 'gerenciamento-pos-graduacao'
  gerenciamentoPosGraduacao: GerenciamentoPosGraduacao;
  controladorGerenciamento = false;
  listaCapacitadora: any[] = [];
  cadastro = this.formBuilder.group({
    pos_graduacao: this.formBuilder.group({
      id_instituicao: [null, [Validators.required]],
      id: [null],
      id_natureza: [null, [Validators.required]],
      observacao: [null, [Validators.maxLength(4000)]],
      titulo: [null, [Validators.required, Validators.maxLength(100)]],
      cpf: [null],
      data_fim: [null, [Validators.required]],
      codigo: [null],
      data_inicio: [null, [Validators.required]],
      carga_horaria: [null, [Validators.required]],
      id_area: [null, [Validators.required]],
      id_situacao: [null],
      tipo_pos_graduacao: [null, [Validators.required]],
      id_capacitadora: [null],
      radio_instituicao_capacitadora: [1],
    }),
    anexo_gerenciar_atividade: this.formBuilder.group({
      id: [null]
    }),
    conteudo: this.formBuilder.group({
      titulo: [null, [Validators.required, Validators.maxLength(100)]],
      descricao: [null, [Validators.required, Validators.maxLength(4000)]]
    }),
    funcao_hipotese: this.formBuilder.group({
      id_funcao_exercida: [null],
      id_hipoteses: [null],
      id: [null],
    }),
    funcao_exercida_hipoteses: [[]],
  });

  listaAnexos: any[] = [];
  listaDadosInstituicao: SelectItem[] = [];
  listaTipoAtividade: SelectItem[] = [];
  listaPntCFC: any[] = [];
  listaPntCRC: any[] = [];
  listaResumo: any[] = [];
  listaRelatores: SelectItem[] = [];
  listaConteudo: any[] = [];
  listaTipoPosGraduacao: any[] = [];
  listaArea: any[] = [];
  mostrarCodigo = false;
  stepObject: any;
  profissionalPodePrestarConta = true;
  validateForm = false;
  setStepObject(obj: any) {
    this.stepObject = obj;
  }

  init() {
    this.service.ListarTodos('instituicao').subscribe(data => {
      this.listaDadosInstituicao = data;
    });
    this.service.ListarTodosCapacitadoraCombo().subscribe(data => {
      this.listaCapacitadora = data;
    });

    this.service.ListarTodos('cursoAcademico').subscribe(data => {
      this.listaArea = data
    });
    this.loadListAsEnum(this.listaTipoPosGraduacao, TipoPosGraduacao);

    this.cadastro.get('pos_graduacao.id_natureza').disable();
    if (this.acao === 'editar') {
      this.cadastro.get('pos_graduacao.data_fim').disable();
    }
  }

  afterInit() {
    this.cadastro.get('pos_graduacao.data_fim').valueChanges.subscribe(x => {
      let fim = new Date(this.cadastro.get('pos_graduacao.data_fim').value);
      this.service.temPendencia(x.getFullYear()).subscribe(pendencia => {

        this.service.obterPrazoPrestacaoProfissional(x.getFullYear()).subscribe((prazo: string) => {
          var foraDoPrazo: boolean = false;

          foraDoPrazo = this.ehProfissional && this.DataSemHora(new Date()) > this.DataSemHora(prazo);

          this.profissionalPodePrestarConta = true;

          let id_situacao = this.cadastro.get('pos_graduacao.id_situacao').value
          if (x && foraDoPrazo && !pendencia && (id_situacao != 13 && id_situacao != 14)) {
            const anoPrestacao = x.getFullYear();
            this.exibirPrestacaoForaDoPrazo(anoPrestacao);
            this.profissionalPodePrestarConta = false;
            this.cadastro.get('pos_graduacao.data_fim').setErrors({ error: `Prestação do ano ${anoPrestacao} já encerrada` });
          }
          else if (!dataFimLimite(fim)) {
            const exercicio: number = new Date().getFullYear();
            this.cadastro.get('pos_graduacao.data_fim').setErrors({ error: `A data fim não pode ser maior que o último dia do exercício vigente: 31/12/${exercicio}.` });
            super.showMsg('warn', 'Data Fim', `A data fim não pode ser maior que o último dia do exercício vigente: 31/12/${exercicio}.`);
            return;
          }

        });
      });
      this.observableUtilPanelDoc.setBlockedPanel(true);
      this.service.ListarTodos('natureza', { query: "Pós Graduação", data: this.cadastro.get('pos_graduacao.data_fim').value }).subscribe(data => {
        this.listaTipoAtividade = data;
        this.cadastro.get('pos_graduacao.id_natureza').enable();
        this.observableUtilPanelDoc.setBlockedPanel(false);
      });
    });
    this.cadastro.get('pos_graduacao.radio_instituicao_capacitadora').valueChanges.subscribe(valor => {
      // tslint:disable-next-line: triple-equals
      if (valor == 1) {
        this.cadastro.get('pos_graduacao.id_instituicao').setValidators([Validators.required]);
        this.cadastro.get('pos_graduacao.id_instituicao').updateValueAndValidity();
        this.cadastro.get('pos_graduacao.id_capacitadora').clearValidators();
        this.cadastro.get('pos_graduacao.id_capacitadora').setValue(null);
        this.cadastro.get('pos_graduacao.id_capacitadora').updateValueAndValidity();
      } else {
        this.cadastro.get('pos_graduacao.id_capacitadora').setValidators([Validators.required]);
        this.cadastro.get('pos_graduacao.id_capacitadora').updateValueAndValidity();
        this.cadastro.get('pos_graduacao.id_instituicao').clearValidators();
        this.cadastro.get('pos_graduacao.id_instituicao').setValue(null)
        this.cadastro.get('pos_graduacao.id_instituicao').updateValueAndValidity();
      }
    })

    if (this.acao == "editar") {
      //Buscar Funcoes Exercidas pelo usuário logado
      this.service
        .ListarTodosGenerics(this.controllerName + "/atividadeFuncaoExercida")
        .subscribe((data) => {
          if (data) {
            this.cadastro.get("funcao_exercida_hipoteses").setValue(data)
          }
        });
    }
  }

  afterLoad() {
    this.mostrarCodigo = true;
    this.cadastro.get('pos_graduacao').patchValue(this.obj);
    this.gerenciamentoPosGraduacao = this.obj;
    if (this.obj.anexo_gerenciar_atividade != null) {
      this.obj.anexo_gerenciar_atividade.forEach(x => {
        x.show = true;
        this.listaAnexos.push(x);
      });
    }
    this.listaConteudo = this.obj.conteudo_pos_graduacao;
    if (this.gerenciamentoPosGraduacao.id_instituicao != null) {
      this.cadastro.get('pos_graduacao.radio_instituicao_capacitadora').setValue(1);
    } else {
      this.cadastro.get('pos_graduacao.radio_instituicao_capacitadora').setValue(2);
    }

    this.obj.homologacao_pos_graduacao.map(item => {
      this.service.ListarTodos('resumoHomologacao', { query: item.id }).subscribe(
        data => {
          this.listaResumo = data;
        }
      );
      if(this.acao !== 'cadastrar') {
        this.service.ListarRelatores('listaRelatoresHomologacao', { query: item.id }).subscribe(
          data => {
              this.listaRelatores = data;
            }
        );
      }
      this.service.ListarPontuacaoHomologacao('homologacao-pos-graduacao', item.id, 'Comissão CFC').subscribe(retorno => {
        this.listaPntCFC = retorno;
      });
      this.service.ListarPontuacaoHomologacao('homologacao-pos-graduacao', item.id, 'Comissão CRC').subscribe(retorno => {
        this.listaPntCRC = retorno;
      });
    });
  }
  carregarObj() {
    this.gerenciamentoPosGraduacao = new GerenciamentoPosGraduacao(this.cadastro.get('pos_graduacao').value, this.listaAnexos, this.listaConteudo);
  }
  finalizar() {
    this.gerenciamentoPosGraduacao.id_lotacao = parseInt(localStorage.getItem('lotacao'));
    if (this.obj != null) {
      this.gerenciamentoPosGraduacao.data_cadastro = this.obj.data_cadastro;
    }
    this.doFinalAction(this.gerenciamentoPosGraduacao, this.controllerName);
  }

}




// WEBPACK FOOTER //
// ./src/app/gerenciamento-pos-graduacao/crud/crud.component.ts